// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, TextField } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// react icons
import { MdDelete } from "react-icons/md";

// components
import DeleteModal from "components/shared/Modal/Delete";
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";

// helper
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
} from "./editCategory.style";

// request methods
import {
  deleteArticleCategoryByIdRequest,
  editArticleCategoryRequest,
  getArticleCategoryByIdRequest,
} from "api/requests/articles";

// validation
import { categorySchema } from "validations";

export default function EditArticlesCategory() {
  const { articles_category_id } = useParams();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // show modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // show modal handler
  const handelShowModal = () => setShowDeleteModal((state) => !state);

  // delete article category
  const handleDeleteItem = useCallback(
    async (id) => {
      setLoading(true);
      const res = await request({
        url: () => deleteArticleCategoryByIdRequest(id),
      });
      setLoading(false);
      if (res) {
        Toast({ type: "success", title: "حذف سردسته اخبار " });
        navigate("/articles/category/add");
      }
      handelShowModal();
    },
    [setLoading]
  );

  // get category data
  const getCategoryData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: () => getArticleCategoryByIdRequest({ id: articles_category_id }),
    });

    setLoading(false);
    if (res) {
      reset({
        title: res.data.title,
      });
    }
  }, [request]);

  // edit category
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        editArticleCategoryRequest({ ...data, id: articles_category_id }),
    });
    setLoading(false);

    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ویرایش سردسته " });
      navigate("/articles/category/add");
    }
  };

  useEffect(() => {
    getCategoryData();
  }, [getCategoryData]);

  return (
    <DrawerCM title="ویرایش سردسته اخبار">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/articles/category/add" />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>ویرایش سردسته اخبار </StyledTitle>
                <Grid container>
                  <Grid item xs={12} p={1.5}>
                    <TextField
                      label="عنوان سردسته"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <ButtonContainer item xs={12}>
                    <Button
                      color="success"
                      startIcon={<CheckIcon />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت
                    </Button>
                    <Button
                      color="error"
                      endIcon={<MdDelete />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handelShowModal();
                      }}
                    >
                      حذف
                    </Button>
                  </ButtonContainer>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handleDeleteItem.bind(null, articles_category_id)}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
